<mat-progress-spinner class="spinner" diameter="20" color="primary" mode="indeterminate"></mat-progress-spinner>
<ng-content select="[loading-icon]" />
